import React from 'react';
import styles from './Updates.module.css';
import UPDATES_LOG from '../updatesData';

function Updates() {
    return (
        <div className={styles.wrapper}>
            <header>
                <h1><span>SYSTEM</span> UPDATES</h1>
            </header>

            {UPDATES_LOG.map((update, index) => {
                const isLatest = index === 0;

                return (
                    <div
                        key={update.version}
                        className={styles.threat_item}
                        style={{
                            opacity: isLatest ? 1 : 0.6,
                            marginTop: '20px'
                        }}
                    >
                        <div className={styles.update_header}>
                            <strong>
                                {update.version} - {update.title}
                                {isLatest && <span className={styles.badge_latest}>LATEST</span>}
                            </strong>

                            <span className={styles.update_date}>
                                [{update.date}]
                            </span>
                        </div>

                        <div className={styles.change_list}>
                            {update.changes.map((change, i) => (
                                <div key={i} className={styles.change_entry}>
                                    <b>{change.label}:</b>
                                    <div className={styles.desc_container}>
                                        {Array.isArray(change.desc) ? (
                                            change.desc.map((line, lineIndex) => (
                                                <span key={lineIndex} className={styles.desc_line}>
                                                    {line}
                                                </span>
                                            ))
                                        ) : (
                                            <span className={styles.desc_line}>{change.desc}</span>
                                        )}
                                    </div>

                                    {change.links && (
                                        <div className={styles.link_wrapper}>
                                            {change.links.map((link, k) => (
                                                <a
                                                    key={k}
                                                    href={link.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.link_block}
                                                >
                                                    {link.text}
                                                    <span className={styles.link_arrow}>↗</span>
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default Updates;